import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

const config = {
  apiKey: 'AIzaSyDu0boOpTxmdTZbn0GPTt5LzY-EotKjM1M',
  authDomain: 'fir-flickontv.firebaseapp.com',
  databaseURL: 'https://fir-flickontv.firebaseio.com',
  projectId: 'firebase-flickontv',
  storageBucket: 'firebase-flickontv.appspot.com',
  messagingSenderId: '638330466398',
};

class Firebase {
  constructor() {
    firebase.initializeApp(config);
    this.store = firebase.firestore;
    this.auth = firebase.auth;
    this.storage = firebase.storage;
    this.firestore = this.store();
    const settings = { timestampsInSnapshots: true };
    this.firestore.settings(settings);
  }

  get episodes() {
    return this.firestore.collection('episodes');
  }

  get programs() {
    return this.firestore.collection('programs');
  }

  get videos() {
    return this.firestore.collection('videos');
  }

  get genres() {
    return this.firestore.collection('genres');
  }

  get webCampaigns() {
    return this.firestore.collection('webCampaigns');
  }
  get entertainers() {
    return this.firestore.collection('entertainers');
  }
}

export default new Firebase();



// WEBPACK FOOTER //
// ./src/services/firebase.js